import axios from "axios";
import { params, header, scopedAnomalyRuleAPI,machineHMIAPI,
  machineNodeAPI,
  machineFunctionAPI, } from "../_api";
import {
  CREATE_SCOPED_ANOMALY_RULE_SUCCESS,
  CREATE_SCOPED_ANOMALY_RULE_FAILURE,
  FETCH_SCOPED_ANOMALY_RULE_FAILURE,
  FETCH_SCOPED_ANOMALY_RULE_SUCCESS,
  DELETE_SCOPED_ANOMALY_RULE_SUCCESS,
  DELETE_SCOPED_ANOMALY_RULE_FAILURE,
  UPDATE_SCOPED_ANOMALY_RULE_SUCCESS,
  UPDATE_SCOPED_ANOMALY_RULE_FAILURE,
  CLEAR_SCOPED_ANOMALY_STATE,
  FETCH_ANOMALY_HMI_SUCCESS,
  FETCH_ANOMALY_HMI_FAILURE,
  FETCH_ANOMALY_NODE_SUCCESS,
  FETCH_ANOMALY_NODE_FAILURE,
  FETCH_ANOMALY_FUNCTION_SUCCESS,
  FETCH_ANOMALY_FUNCTION_FAILURE,
  HMI_REQUEST,
  NODE_REQUEST,
  FUNCTION_REQUEST,
  CLEAR_TYPE_HMI,
  CLEAR_TYPE_NODE,
  CLEAR_TYPE_FUNCTION
} from "../_constants";

const createScopedAnomalyRuleSuccess = (data) => {
  return { type: CREATE_SCOPED_ANOMALY_RULE_SUCCESS };
};

const createScopedAnomalyRuleFailure = (error) => {
  return { type: CREATE_SCOPED_ANOMALY_RULE_FAILURE, payload: error };
};

//create scoped anomaly rule

export const createScopedAnomalyRule = (body,machine_type,hmi_type, createSuccessFlag) => {
  return async (dispatch) => {
    return axios({
      method: "post",
      url: scopedAnomalyRuleAPI,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: body,
    })
      .then((response) => {
        dispatch(createScopedAnomalyRuleSuccess(response.data));
        createSuccessFlag(body.anomaly_rule_id, body.scope);
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(createScopedAnomalyRuleFailure(errorMsg));
      });
  };
};

const fetchScopedAnomalyRuleSuccess = (data) => {
  return { type: FETCH_SCOPED_ANOMALY_RULE_SUCCESS, payload: data };
};

const fetchScopedAnomalyRuleFailure = (error) => {
  return { type: FETCH_SCOPED_ANOMALY_RULE_FAILURE, payload: error };
};

//fetch scoped anomaly rule
export const fetchScopedAnomalyRule = (queryParams = {}) => {
  return async (dispatch) => {
    return axios({
      method: "get",
      url: scopedAnomalyRuleAPI,
      params: {
        ...params,
        ...queryParams,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(fetchScopedAnomalyRuleSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchScopedAnomalyRuleFailure(errorMsg));
      });
  };
};

const deleteScopedAnomalyRuleSuccess = (data) => {
  return { type: DELETE_SCOPED_ANOMALY_RULE_SUCCESS, payload: data };
};

const deleteScopedAnomalyRuleFailure = (error) => {
  return { type: DELETE_SCOPED_ANOMALY_RULE_FAILURE, payload: error };
};

//delete Scoped anomaly rule
export const deleteScopedAnomalyRule = (queryParams,machine_type, hmi_type) => {
  return async (dispatch) => {
    return axios({
      method: "delete",
      url: scopedAnomalyRuleAPI,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        ...queryParams,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
    })
      .then((response) => {
        dispatch(deleteScopedAnomalyRuleSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(deleteScopedAnomalyRuleFailure(errorMsg));
      });
  };
};

const updateScopedAnomalyRuleSuccess = (data) => {
  return { type: UPDATE_SCOPED_ANOMALY_RULE_SUCCESS, payload: data };
};

const updateScopedAnomalyRuleFailure = (error) => {
  return { type: UPDATE_SCOPED_ANOMALY_RULE_FAILURE, payload: error };
};

//update Scoped anomaly rule
export const updateScopedAnomalyRule = (body, machine_type,hmi_type, setUpdateDialogOpen) => {
  return async (dispatch) => {
    return axios({
      method: "put",
      url: scopedAnomalyRuleAPI,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: body,
    })
      .then((response) => {
        dispatch(updateScopedAnomalyRuleSuccess(response.data, true));
        setUpdateDialogOpen(true);
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(updateScopedAnomalyRuleFailure(errorMsg));
      });
  };
};

export const clearScopedAnomalyState = () => {
  return { type: CLEAR_SCOPED_ANOMALY_STATE };
};

export const fetchHMIRequest = () => {
  return { type: HMI_REQUEST };
};


const fetchAnomalyHMISuccess = (data) => {
  return { type: FETCH_ANOMALY_HMI_SUCCESS, payload: data };
};

const fetchAnomalyHMIFailure = (error) => {
  return { type: FETCH_ANOMALY_HMI_FAILURE, payload: error };
};

export const fetchAnomalyHMI = (queryParams) => {
  return async (dispatch) => {
    dispatch(fetchHMIRequest())
    return axios
      .get(machineHMIAPI, {
        params: { ...params, ...queryParams,userid: sessionStorage.getItem('userId')},
        headers: header,
      })
      .then((response) => {
        dispatch(fetchAnomalyHMISuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchAnomalyHMIFailure(errorMsg));
      });
  };
};

export const fetchNodeRequest = () => {
  return { type: NODE_REQUEST };
};


const fetchAnomalyNodeSuccess = (data) => {
  return { type: FETCH_ANOMALY_NODE_SUCCESS, payload: data };
};

const fetchAnomalyNodeFailure = (error) => {
  return { type: FETCH_ANOMALY_NODE_FAILURE, payload: error };
};

export const fetchAnomalyNode = (queryParams) => {
  return async (dispatch) => {
    dispatch(fetchNodeRequest())
    return axios
      .get(machineNodeAPI, {
        params: { ...params, ...queryParams,userid: sessionStorage.getItem('userId') },
        headers: header,
      })
      .then((response) => {
        dispatch(fetchAnomalyNodeSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchAnomalyNodeFailure(errorMsg));
      });
  };
};

export const fetchFunctionRequest = () => {
  return { type: FUNCTION_REQUEST };
};

const fetchAnomalyFunctionSuccess = (data) => {
  return { type: FETCH_ANOMALY_FUNCTION_SUCCESS, payload: data };
};

const fetchAnomalyFunctionFailure = (error) => {
  return { type: FETCH_ANOMALY_FUNCTION_FAILURE, payload: error };
};

export const fetchAnomalyFunction = (queryParams) => {
  return async (dispatch) => {
    dispatch(fetchFunctionRequest())
    return axios
      .get(machineFunctionAPI, {
        params: { ...params, ...queryParams,userid: sessionStorage.getItem('userId')},
        headers: header,
      })
      .then((response) => {
        dispatch(fetchAnomalyFunctionSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchAnomalyFunctionFailure(errorMsg));
      });
  };
};

export const clearTypeHmi = () => {
  return { type: CLEAR_TYPE_HMI };
};
export const clearTypeNode = () => {
  return { type: CLEAR_TYPE_NODE };
};
export const clearTypeFunction = () => {
  return { type: CLEAR_TYPE_FUNCTION };
};